<template>
  <v-container fluid>
    <v-data-table
      :headers="dessertHeaders"
      :items="agents"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      :search="search"
      item-key="id_agent"
      show-expand
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Agent Data</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            solo
            dense
            append-icon="mdi-magnify"
            label="Search Agent Data"
            class="mr-3 white"
            outlined
            hide-details
          ></v-text-field>
          <v-dialog
            v-model="dialog"
            persistent
            width="800"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="primary"
                v-bind="attrs"
                v-on="on"
              >
                Add New Agent  <v-icon>{{ icons.mdiPlus }}</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="">
                <span class="text-h6 ">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col md="6">
                    <v-text-field
                      v-model="form.agent_name"
                      dense
                      outlined
                      placeholder="Agent Name"
                      label="Agent Name"
                    />
                    <v-text-field
                      v-model="form.agent_code"
                      dense
                      outlined
                      placeholder="Agent Code"
                      label="Agent Code"
                    />
                    <v-text-field
                      v-model="form.phone"
                      type="number"
                      dense
                      outlined
                      placeholder="Phone"
                      label="Phone"
                    />

                    <v-text-field
                      v-model="form.email"
                      dense
                      outlined
                      placeholder="Email"
                      label="Email"
                    />
                  </v-col>
                  <v-col>
                    <v-autocomplete
                      v-model="form.city"
                      :items="regions"
                      item-text="region_name"
                      item-value="id_region"
                      dense
                      outlined
                      placeholder="Region"
                      label="Region"
                    />
                    <v-textarea
                      v-model="form.note"
                      label="Notes"
                      placeholder="Notes"
                      outlined
                      dense
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  class="text-capitalize"
                  text
                  @click="CekDialog()"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  class="text-capitalize"
                  text
                  @click="Save"
                >
                  {{ TittleButton }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-row>
            <v-col>
              <v-simple-table>
                <tbody>
                  <tr>
                    <td>Notes</td>
                    <td colspan="2">
                      : {{ item.note }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </td>
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn
          small
          class="mr-2 text-capitalize primary"
          @click="editItem(item)"
        >
          <v-icon>{{ icons.mdiPencil }}</v-icon>
        </v-btn>
        <v-btn
          small
          class="mr-2 text-capitalize primary"
          @click="deleteItem(item)"
        >
          <v-icon>{{ icons.mdiTrashCan }}</v-icon>
        </v-btn>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import axios from 'axios'
import {
  mdiPencil,
  mdiTrashCan,
  mdiPlus,
  mdiClose,
  mdiCalendar,
} from '@mdi/js'

export default {

  data() {
    return {
      icons: {
        mdiPencil,
        mdiTrashCan,
        mdiPlus,
        mdiClose,
        mdiCalendar,
      },
      modal: false,
      modal5: false,
      expanded: [],
      singleExpand: true,
      dialog: false,
      editedIndex: -1,
      search: '',
      form: {
        agent_name: '',
        agent_code: '',
        id_agent: '',
        phone: '',
        email: '',
        city: '',
        note: '',
      },
      service: [],
      dessertHeaders: [
        { text: 'Agent Name', value: 'agent_name' },
        { text: 'Agent Code', value: 'agent_code' },
        { text: 'Region', value: 'region_name' },
        { text: 'Phone', value: 'phone' },
        { text: 'Email', value: 'email' },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          width: 200,
        },
      ],

      agents: [],
      regions: [],

    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Add New Agent' : 'Edit Agent'
    },
    TittleButton() {
      return this.editedIndex === -1 ? 'Save Agent' : 'Update Agent'
    },
  },

  mounted() {
    this.initialize()
    this.initializeregion()
  },
  methods: {
    initializeregion() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.get('auth/Region').then(response => {
        this.regions = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    CekDialog() {
      this.form = {
        agent_name: '',
        agent_code: '',
        id_agent: '',
        phone: '',
        email: '',
        city: '',
        note: '',
      }
      this.dialog = false
    },

    editItem(item) {
      this.editedIndex = this.agents.indexOf(item)
      this.form = item
      this.dialog = true
    },
    deleteItem(item) {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/DeleteAgent', item).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    initialize() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.get('auth/Agent').then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.agents = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    Save() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/SaveAgent', this.form).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
        this.dialog = false
        this.CekDialog()
        this.editedIndex = -1
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
  },
}
</script>
